import httpClient from 'shared/lib/httpClient';
import { parseRoleOptions } from '../schemas/MasterDataSchema';

export const getRoleOptions = async (params, signal) => {
  const response = await httpClient.get('/options/company-roles', {
    params,
    signal,
  });
  return parseRoleOptions(response?.data);
};
